import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool } from '@/tool'
let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let { Session } = utils_tool
class ThirdApp extends WizContainer {

  componentName = 'thirdApp';

  constructor(props) {
      
    const { history } = props;
    let record = {};
    if (history.location && history.location.pathname === '/auth/corpManager/appManager') {
        if(history.location && history.location.record){
            record = history.location.record;
            Session.set('thirdAppInfo',record)
        }else{
          record = Session.get('thirdAppInfo') || {};
        }
        }
    super(props);
    this.state = {
        record,
        corpList:null
    }
  }
  _componentDidMount() {
    const { history } = this.props;
    this.doActions([
      {
        path: 'thirdCopr/list', //获取企业信息
        payload: {
          key: 'thirdApp@corpList',
          apiParams: {
            type: 'FOLDER'
          }
        },
        requireLoading: true,
      }
    ])
  }

  propsAndStateOnChange = {
    corpList: this.corpListOnChange.bind(this)
  }
  corpListOnChange(nextProps, nextState) {
    let _list = [];
    if (nextProps['corpList'] && nextProps['corpList']['success'] === true) {
      let list = nextProps["corpList"]['data']
      list && list.forEach(val => {
        _list.push({ code: val['id'], codeName: val['name'] })
      });
      nextState['corpList'] = _list;
      return true;
    } else {
      wizNotice.error(_nextProps["corpList"]['msg'])
      return false;
    }
  }
  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
      const {corpList,record} = this.state
      const {id} = record ||{}
      let data = {corpList,corpInfoId:id}
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig(data),
      corpInfoId:id,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
    const { thirdCopr } = state;
    const corpList = modelUtils.getModelEntity(thirdCopr, "thirdApp@corpList");
    return {
        corpList: corpList,
    }
};

export default connect(mapStateToProps)(ThirdApp);
